import '../Cookie'
import '../Message'
import 'Agronomy/Context'
import 'Glonass/Application'
import 'Xhr'
import './UI/UI'

/** @namespace Agronomy */
NS("Agronomy");

/**
 * @class
 * @extends Glonass.Application
 */
Agronomy.Application = Class(Glonass.Application, /** @lends Agronomy.Application.prototype */{
    uiClass: "Agronomy.UI.UI",
    /**
     * @returns {Agronomy.Context}
     */
    createContext()
    {
        return new Agronomy.Context();
    },

    init(callback) {
        const parentMethod = this.ParentMethod();

        this.readConfiguration()
            .then(config => {
                this.configuration = config

                return this::parentMethod(() => {
                    Message.url = config.message.url
                    Message.sessionId = context('sessionId')
                    Message.connect()
                    callback()
                })
            })
            .catch(err => {
                alert(err.message);
                console.error(err.stack);
            });

        return this;
    },
});
